export const APPLE_APP_STORE_URL =
    'https://apps.apple.com/us/app/plenty-financial/id6636471489';
export const GOOGLE_PLAY_STORE_URL =
    'https://play.google.com/store/apps/details?id=com.withplenty.app';
